// Simplified color configuration for the application
export const THEME_MODES = [
  { value: "light", label: "Light" },
  { value: "dark",  label: "Dark"  },
];

export const PRIMARY_COLORS = [
  { value: "blue-600",    label: "Blue",   category: "blue" },
  { value: "indigo-600",  label: "Indigo", category: "indigo" },
  { value: "violet-600",  label: "Purple", category: "purple" },
  { value: "pink-600",    label: "Pink",   category: "pink" },
  { value: "red-600",     label: "Red",    category: "red" },
  { value: "orange-700",  label: "Orange", category: "orange" },
  { value: "amber-600",   label: "Amber",  category: "amber" },
  { value: "emerald-600", label: "Green",  category: "green" },
  { value: "teal-600",    label: "Teal",   category: "teal" },
  { value: "gray-600",    label: "Gray",   category: "gray" },
];

// Default colors
export const DEFAULT_COLORS = {
  primary: "blue-600",
  themeMode: "light",
};

export const getColorLabel = (colorValue) => {
  const primaryColor = PRIMARY_COLORS.find((c) => c.value === colorValue);
  if (primaryColor) return primaryColor.label;

  return colorValue.replace("-", " ").toUpperCase();
};
